/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './checkHandleAvailability.defs.js'
export { main as default } from './checkHandleAvailability.defs.js'
